import React from 'react'
import { Stack } from '@mui/material'
import RoleItem from '../RoleItem'
import CategoryHeader from '../CategoryHeader'
import Group from '../Group'
import { isRoleDisabled } from '../../../../helpers'
import type { CategoryType, ContactRoles } from '../../../../types'
import type { Contact } from '__generated__/graphql'
import type { User } from 'models/user.model'

interface EditSectionLayoutProps {
  category: CategoryType
  visibleRoles: [string, boolean | undefined][]
  roles: ContactRoles
  user: User
  contact: Contact | null
  withBorder: boolean
  colorScheme: 'blue' | 'green'
  compact: boolean
  allSelected?: boolean
  hasSelection?: boolean
  onAddAll?: () => void
  onReset?: () => void
  onToggleAll?: () => void
  isRoleEdit?: boolean
}

const EditSectionLayout: React.FC<EditSectionLayoutProps> = ({
  category,
  visibleRoles,
  roles,
  user,
  contact,
  withBorder,
  colorScheme,
  compact,
  allSelected,
  hasSelection,
  onAddAll,
  onReset,
  onToggleAll,
  isRoleEdit = false
}) => {  
  const headerProps = compact || isRoleEdit
    ? {
        compact: true,
        allSelected: allSelected || false,
        onAddAll,
        onReset,
        isRoleEdit
      }
    : {
        compact: false,
        withBorder,
        hasSelection: hasSelection || false,
        onToggleAll
      }

  const containerSx = isRoleEdit ? {
    border: '1px solid #EFEFEF',
    borderRadius: '24px',
    p: 3,
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  } : (compact ? { p: '4px 8px' } : {})

  const spacing = compact || isRoleEdit ? 0.25 : undefined

  const roleItems = (
    <Stack spacing={spacing} sx={isRoleEdit ? { flex: 1 } : {}}>
      {visibleRoles.map(([role], index) => (
        <RoleItem
          key={`${role}-${index}`}
          mode="edit"
          role={role}
          checked={roles?.[role] || false}
          disabled={isRoleDisabled(role, user, contact)}
          padding={withBorder ? '16px' : '0px'}
          compact={compact || isRoleEdit}
          colorScheme={colorScheme}
          isGeneral={category.name === 'general' && isRoleEdit}
        />
      ))}
    </Stack>
  )

  return (
    <Stack gap={compact || isRoleEdit ? 2 : 0.5} sx={containerSx}>
      <CategoryHeader
        categoryName={category.name}
        {...headerProps}
      />
      {compact || isRoleEdit ? roleItems : (
        <Group withBorder={withBorder}>
          {roleItems}
        </Group>
      )}
    </Stack>
  )
}

export default EditSectionLayout